import { adminApiFetch } from './apiService';

export const sluggishProductService = {
  query: async (params) => {
    const response = await adminApiFetch('products/sluggish_products', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  }
};

export default sluggishProductService;
